import React, { useState, useEffect } from "react";
import Footer from "../components/Footer";
import Inquiry from "../components/inquiry";
import Testimonials from "../components/ClientTestimonials";
import {
  ChevronRight,
  Clock,
  DollarSign,
  Shield,
  Users,
  FileText,
  CheckCircle,
  Star,
  ArrowRight,
  Mail,
  Phone,
  MapPin,
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
  Award,
  Building,
  Target,
  Heart,
} from "lucide-react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import bgImage from "../assets/p1.jpg"; // Use your image path here
import d1 from "../assets/director1.png";
import d2 from "../assets/director2.png";

const PMCLandingPage = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    projectDetails: "",
  });

  const testimonials = [
    {
      text: "Having a beautiful home or residence is one of the most important dreams of everyone. Everyone in this world wishes for a perfect residence with everything precisely designed and decorated. Arch Point designed the best home architecture plan for us to live our dreams.",
      author: "Satisfied Client",
      company: "Residential Project",
      rating: 5,
    },
    {
      text: "We thoroughly know the demand of time in the field of architecture, and Arch Point's team delivers exactly what we envisioned while dealing with social, economic, geographic and cultural constraints to assure the finest results.",
      author: "Commercial Client",
      company: "Commercial Development",
      rating: 5,
    },
    {
      text: "Their main focus before starting any project was to do deep research in relevance with our amenities. Design is indeed a process, and Arch Point proved it cannot be done 'In the Flick of an Eye'.",
      author: "Institutional Client",
      company: "Educational Facility",
      rating: 5,
    },
  ];

  const processSteps = [
    {
      title: "Research & Analysis",
      description: "Deep research about client needs and site conditions",
    },
    {
      title: "Conceptual Design",
      description: "Innovative ideas with scientific and artistic approach",
    },
    {
      title: "Design Development",
      description:
        "Detailed planning with social, economic, and cultural considerations",
    },
    {
      title: "Project Execution",
      description: "High quality design and vastu solutions implementation",
    },
    {
      title: "Client Satisfaction",
      description:
        "Proper presentation so you can visualize your dream in reality",
    },
  ];

  const benefits = [
    {
      icon: <Target className="w-8 h-8 text-yellow-500" />,
      title: "Accuracy is our Goal",
      description: "Precise planning and execution for every project milestone",
    },
    {
      icon: <Heart className="w-8 h-8 text-yellow-500" />,
      title: "Design is our Love",
      description: "Passionate approach to architectural excellence",
    },
    {
      icon: <Shield className="w-8 h-8 text-yellow-500" />,
      title: "Quality Assurance",
      description:
        "High quality design solutions across different project magnitudes",
    },
    {
      icon: <Users className="w-8 h-8 text-yellow-500" />,
      title: "Expert Team",
      description: "Professionals with marvelous experience in architecture",
    },
    {
      icon: <Building className="w-8 h-8 text-yellow-500" />,
      title: "Quantum Architecture",
      description:
        "Specialized in quantum architecture - your vibes matter to us",
    },
  ];

  const coreValues = [
    { letter: "A", value: "Authentic" },
    { letter: "R", value: "Responsible" },
    { letter: "C", value: "Confident" },
    { letter: "H", value: "Honest" },
    { letter: "P", value: "Passionate" },
    { letter: "O", value: "Optimistic" },
    { letter: "I", value: "Impressive" },
    { letter: "N", value: "Noble" },
    { letter: "T", value: "Trustworthy" },
  ];

  // Main number cards (numbers only)
  const stats = [
    {
      number: 500,
      suffix: "+",
      label: "Projects",
      subtitle: "Thanks to all visionaries for believing in Arch Point",
    },
    {
      number: 10,
      suffix: "+",
      label: "Cities",
      subtitle: "We believe in growing together",
    },
    {
      number: 100,
      suffix: "+",
      label: "Team Members",
      subtitle: "Dedicated team which believes design is our love",
    },
  ];

  // Recognition cards (separate card style)
  const recognitions = [
    {
      icon: <Award className="w-7 h-7" />,
      label: "ISO Recognition",
      subtitle: "Recognised for our commitment",
    },
    {
      icon: <Shield className="w-7 h-7" />,
      label: "Govt. Recognition",
      subtitle: "Recognised as startup by Government of India",
    },
  ];

  const projectCategories = [
    { icon: "🏡", label: "Residential" },
    { icon: "🏢", label: "Commercial" },
    { icon: "🏨", label: "Resorts & Hotels" },
    { icon: "🎭", label: "Auditoriums" },
    { icon: "🏟️", label: "Sports Complexes" },
    { icon: "🏘️", label: "Townships" },
    { icon: "🕌", label: "Religious Projects" },
    { icon: "✨", label: "& More" },
  ];
  const services = [
    {
      icon: "🏛️",
      title: "Architectural Design",
      description:
        "Innovative and sustainable design solutions tailored to your vision and requirements.",
    },
    {
      icon: "🛋️",
      title: "Interior Design",
      description:
        "Creating aesthetically refined and functional spaces that reflect your personality and purpose.",
    },
    {
      icon: "📋",
      title: "Project Management Consultancy (PMC)",
      description:
        "Seamless planning, coordination, and execution to ensure timely and cost-effective project delivery.",
    },
    // {
    //   icon: "🏨",
    //   title: "Hospitality Projects",
    //   description:
    //     "Crafting immersive hospitality environments that balance luxury, comfort, and brand identity.",
    // },
    // {
    //   icon: "🏢",
    //   title: "Commercial Developments",
    //   description:
    //     "Purpose-driven commercial spaces designed for productivity, footfall, and lasting impressions.",
    // },
    // {
    //   icon: "🏡",
    //   title: "Residential Projects",
    //   description:
    //     "Thoughtfully designed homes that harmonize aesthetics, functionality, and everyday living.",
    // },
    // {
    //   icon: "🗺️",
    //   title: "Master Planning",
    //   description:
    //     "Holistic urban and site planning strategies that shape communities and future growth.",
    // },
    // {
    //   icon: "🌿",
    //   title: "Landscape Design",
    //   description:
    //     "Outdoor environments that complement built form and connect people with nature.",
    // },
    // {
    //   icon: "💡",
    //   title: "Lighting Design",
    //   description:
    //     "Curated lighting concepts that enhance mood, form, and spatial experience.",
    // },
    // {
    //   icon: "🪑",
    //   title: "Furniture Design",
    //   description:
    //     "Custom furniture solutions that marry craftsmanship with spatial harmony.",
    // },
    // {
    //   icon: "🏋️",
    //   title: "Health Clubs & Spas",
    //   description:
    //     "Wellness spaces designed with purpose — blending tranquility, function, and premium finishes.",
    // },
    // {
    //   icon: "🏫",
    //   title: "Institutional Buildings",
    //   description:
    //     "Educational and civic architecture built to inspire, endure, and serve communities.",
    // },
    // {
    //   icon: "🧪",
    //   title: "Pharmaceutical Facilities",
    //   description:
    //     "Precision-planned facilities that meet stringent compliance while optimizing workflow.",
    // },
  ];
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleFormChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const directors = [
    {
      id: 1,
      name: "Ar. Amit Khandelwal",
      title: "Principal Architect & Founder",
      image: d1,
      description:
        "Dynamic professional with expertise in sustainable design and commercial architecture from Aayojan School of Architecture.",
      expertise: [
        "Sustainable Design",
        "Urban Planning",
        "Commercial Architecture",
      ],
      projects: "200+",
    },
    {
      id: 2,
      name: "Ar. Poonam Jain",
      title: "Co-Founder & Design Director",
      image: d2,
      description:
        "Specialized in interior design and residential projects with a keen eye for space planning and aesthetic excellence.",
      expertise: ["Interior Design", "Residential Projects", "Space Planning"],
      projects: "150+",
    },
  ];
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3, // Adjust if needed
  });
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      {/* Hero Section */}
      <section
        id="home"
        className="relative min-h-screen py-24 flex items-center justify-center overflow-hidden"
      >
        {/* Background Image with Dark Overlay */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.4)), url(${bgImage})`,
          }}
        ></div>

         {/* Foreground Content */}
        <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight">
            YOUR DREAM IS
            <span className="text-yellow-400"> <br/> OUR MISSION</span>
          </h1>
          {/* <p className="text-lg sm:text-xl md:text-2xl text-gray-200 mb-4 max-w-3xl mx-auto">
            We turn your vision into thoughtfully designed spaces, bringing together architecture, interiors, functionality and timeless design to create places you’re proud to call your own.
          </p> */}
          <p className="text-base sm:text-lg md:text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            We turn your vision into thoughtfully designed spaces, bringing together architecture, interiors, functionality and timeless design to create places you’re proud to call your own.
          </p>
          <button
            onClick={() => {
              document
                .getElementById("contact")
                ?.scrollIntoView({ behavior: "smooth" });
            }}
            className="bg-yellow-500 hover:bg-yellow-600 text-black font-semibold px-6 py-3 sm:px-8 sm:py-4 rounded-lg text-base sm:text-lg transition-colors inline-flex items-center group"
          >
            Start Your Dream Project
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
              Our Mission
            </h2>
            <div className="max-w-4xl mx-auto">
              <p className="text-lg sm:text-xl lg:text-2xl text-yellow-600 font-semibold mb-4 italic leading-snug">
                "We turn your vision into thoughtfully designed spaces, bringing
                together architecture, interiors, functionality and timeless
                design to create places you are proud to call your own"
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">
                Arch Point Consultants Pvt. Ltd.
              </h3>
              <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed">
                Arch Point Consultants Pvt. Ltd. stands out as an award-winning
                consultancy with over 20+ years of excellence in Architecture,
                Interior designing and PMC.
              </p>
              <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed">
                Founded by Ar. Amit Khandelwal and Ar. Poonam Jain, the firm is
                widely recognized for its Quantum Architecture approach, where
                science, Vastu, energy alignment, and design innovation come
                together to create spaces that perform far beyond aesthetics.
              </p>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
                The diverse global portfolio reflects technical mastery,
                thoughtful planning, and value-driven execution, setting new
                benchmarks in holistic and future-ready design.
              </p>
            </div>
            <div className="relative">
              <div className="bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-2xl p-4 sm:p-8 text-center md:rotate-2 md:hover:rotate-0 transition-transform">
                <div className="bg-white rounded-xl p-6 sm:p-8">
                  <div className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
                    Your Dream Is Our Mission
                  </div>
                  <div className="text-sm sm:text-base text-gray-600 mb-2">
                    Comprehensive solutions in
                  </div>
                  <div className="text-gray-900 font-semibold text-base sm:text-lg">
                    Architecture, Interior Design & Project Management
                  </div>
                  <div className="mt-4 text-yellow-600 font-medium">
                    From Concept to Completion
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values: connected, linear layout */}
      <section className="py-12 sm:py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Our Core Values
            </h2>
            <p className="text-lg sm:text-xl text-gray-600">
              The ARCHPOINT way of excellence
            </p>
          </div>

          {/* Large screens: one horizontal line running through all nine values */}
          <div className="hidden lg:block relative">
            <div
              aria-hidden="true"
              className="absolute top-7 left-[5.55%] right-[5.55%] h-1 -translate-y-1/2 rounded-full bg-gradient-to-r from-yellow-300 to-yellow-500"
            />
            <div className="relative grid grid-cols-9">
              {coreValues.map((item, index) => (
                <div key={index} className="text-center group">
                  <div className="bg-yellow-500 text-black w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-3 text-xl font-bold ring-4 ring-white group-hover:bg-yellow-600 transition-colors">
                    {item.letter}
                  </div>
                  <p className="text-sm font-medium text-gray-700">
                    {item.value}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile and tablet: vertical connected line */}
          <div className="lg:hidden relative max-w-xs mx-auto">
            <div
              aria-hidden="true"
              className="absolute left-5 top-5 bottom-5 w-0.5 -translate-x-1/2 bg-yellow-300"
            />
            <ol className="relative">
              {coreValues.map((item, index) => (
                <li
                  key={index}
                  className="flex items-center gap-4 pb-5 last:pb-0"
                >
                  <div className="shrink-0 bg-yellow-500 text-black w-10 h-10 rounded-full flex items-center justify-center text-lg font-bold ring-4 ring-white">
                    {item.letter}
                  </div>
                  <p className="text-base font-medium text-gray-700">
                    {item.value}
                  </p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </section>

      {/* Key Benefits */}
      <section id="services" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Why Choose Arch Point
            </h2>
            <p className="text-lg sm:text-xl text-gray-600">
              Our commitment to excellence in every project
            </p>
          </div>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-8">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="text-center group hover:transform hover:scale-105 transition-all bg-white p-6 rounded-xl shadow-sm"
              >
                <div className="bg-yellow-50 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4 group-hover:bg-yellow-100 transition-colors">
                  {benefit.icon}
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 text-sm">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-24 bg-gradient-to-br from-slate-50 via-yellow-50 to-amber-50 relative overflow-hidden">
        {/* Background blobs */}
        <div className="absolute inset-0 opacity-5 pointer-events-none">
          <div className="absolute top-10 left-10 w-80 h-80 bg-yellow-300 rounded-full blur-3xl" />
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-amber-200 rounded-full blur-3xl" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-yellow-100 rounded-full border border-yellow-200 mb-6">
              <span className="w-2 h-2 rounded-full bg-yellow-500 animate-pulse" />
              <span className="text-yellow-700 font-semibold text-sm uppercase tracking-widest">
                What We Offer
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
              Our <span className="text-yellow-500">Services</span>
            </h2>
            <p className="text-lg text-slate-500 max-w-2xl mx-auto leading-relaxed">
              Comprehensive architectural and design solutions from concept to
              completion.
            </p>
            <div className="mt-6 w-20 h-1 bg-gradient-to-r from-yellow-400 to-amber-500 mx-auto rounded-full" />
          </div>

          {/* Top 3 Featured Cards */}
          <div className="grid md:grid-cols-3 gap-6 mb-8">
            {services.slice(0, 3).map((service, index) => (
              <div
                key={index}
                className="group bg-white rounded-2xl p-8 shadow-sm border border-yellow-100 hover:shadow-xl hover:border-yellow-300 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-14 h-14 bg-yellow-50 border border-yellow-200 rounded-xl flex items-center justify-center text-2xl mb-5 group-hover:bg-yellow-100 transition-colors duration-300">
                  {service.icon}
                </div>
                <h3 className="text-lg font-bold text-slate-800 mb-3 group-hover:text-yellow-600 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-slate-500 text-sm leading-relaxed">
                  {service.description}
                </p>
                <div className="mt-5 w-8 h-0.5 bg-yellow-400 rounded-full group-hover:w-16 transition-all duration-300" />
              </div>
            ))}
          </div>

          {/* Remaining Services Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
            {services.slice(3).map((service, index) => (
              <div
                key={index}
                className="group bg-white rounded-xl p-5 border border-gray-100 hover:border-yellow-300 hover:shadow-md transition-all duration-300 hover:-translate-y-0.5"
              >
                <div className="text-xl mb-3">{service.icon}</div>
                <h4 className="text-sm font-bold text-slate-700 mb-2 group-hover:text-yellow-600 transition-colors duration-300 leading-snug">
                  {service.title}
                </h4>
                <p className="text-xs text-slate-400 leading-relaxed line-clamp-2">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Process Flow */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Our Process
            </h2>
            <p className="text-lg sm:text-xl text-gray-600 italic">
              Design is a process, and it cannot be done in the flick of an eye
            </p>
          </div>

          {/* Desktop */}
          <div className="hidden md:flex items-start">
            {processSteps.map((step, index) => (
              <React.Fragment key={index}>
                {index > 0 && (
                  <div className="flex-1 h-16 flex items-center px-2">
                    <div
                      className="process-line-fill flex-1 rounded-full"
                      style={{
                        height: "4px",
                        background: "linear-gradient(90deg, #fbbf24, #f59e0b)",
                        animationDelay: `${index * 180}ms`,
                      }}
                    />
                    <ChevronRight
                      className="process-arrow text-amber-500 -ml-1 shrink-0"
                      size={24}
                      strokeWidth={2.5}
                      style={{ animationDelay: `${index * 180 + 220}ms` }}
                    />
                  </div>
                )}
                <div
                  className="process-step flex flex-col items-center text-center px-3"
                  style={{
                    minWidth: "150px",
                    animationDelay: `${index * 180}ms`,
                  }}
                >
                  <div className="h-16 flex items-center justify-center">
                    <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center border-4 border-amber-400 shadow-md hover:scale-105 hover:shadow-lg transition-all duration-300">
                      <span className="text-xl font-bold text-amber-600">
                        {index + 1}
                      </span>
                    </div>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mt-5 mb-2">
                    {step.title}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </React.Fragment>
            ))}
          </div>

          {/* Mobile: stacked list, no connectors */}
          <div className="md:hidden grid grid-cols-1 gap-8">
            {processSteps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 border-4 border-amber-400 shadow-md">
                  <span className="text-xl font-bold text-amber-600">
                    {index + 1}
                  </span>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        <style>{`
          @keyframes segmentGrow {
            from { transform: scaleX(0); }
            to { transform: scaleX(1); }
          }
          @keyframes arrowPop {
            from { opacity: 0; transform: translateX(-6px); }
            to { opacity: 1; transform: translateX(0); }
          }
          @keyframes stepPopIn {
            from { opacity: 0; transform: translateY(16px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .process-line-fill {
            transform: scaleX(0);
            transform-origin: left;
            animation: segmentGrow 0.45s ease-out forwards;
          }
          .process-arrow {
            opacity: 0;
            animation: arrowPop 0.3s ease-out forwards;
          }
          .process-step {
            opacity: 0;
            animation: stepPopIn 0.6s ease-out forwards;
          }
        `}</style>
      </section>

      {/* ── Arch Point Advantages ── */}
      <section
        className="py-16 sm:py-24 bg-yellow-500 relative overflow-hidden"
        ref={ref}
      >
        {/* subtle texture rings */}
        <div className="absolute inset-0 pointer-events-none opacity-10">
          <div className="absolute -top-20 -left-20 w-96 h-96 border-4 border-white rounded-full" />
          <div className="absolute -bottom-20 -right-20 w-80 h-80 border-4 border-white rounded-full" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] border border-white rounded-full" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-10 sm:mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full border border-white/30 mb-5">
              <span className="w-2 h-2 rounded-full bg-white animate-pulse" />
              <span className="text-white font-semibold text-sm uppercase tracking-widest">
                Why Choose Us
              </span>
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3">
              Arch Point <span className="text-yellow-900">Advantages</span>
            </h2>
            <p className="text-white font-bold text-base sm:text-lg max-w-xl mx-auto drop-shadow-sm">
              Numbers that reflect our passion, dedication, and trust earned
              over the years.
            </p>
          </div>

          {/* Main number cards (numbers only) */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 max-w-5xl mx-auto">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="group bg-black/10 backdrop-blur-sm border border-white/30 rounded-2xl p-6 text-center hover:bg-black/15 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
              >
                {/* Number */}
                <div className="text-4xl sm:text-5xl font-extrabold text-white mb-1 tracking-tight">
                  {inView ? (
                    <CountUp end={stat.number} duration={2} />
                  ) : (
                    "0"
                  )}
                  {stat.suffix}
                </div>

                {/* Label */}
                <div className="text-white font-bold text-lg mb-2">
                  {stat.label}
                </div>

                {/* Divider */}
                <div className="w-8 h-0.5 bg-white/60 mx-auto mb-3 group-hover:w-14 transition-all duration-300 rounded-full" />

                {/* One-liner */}
                <p className="text-white font-bold text-sm leading-snug drop-shadow-sm">
                  {stat.subtitle}
                </p>
              </div>
            ))}
          </div>

          {/* Recognition cards (separate style) */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 max-w-3xl mx-auto mt-8 sm:mt-10">
            {recognitions.map((item, index) => (
              <div
                key={index}
                className="flex items-center gap-4 bg-slate-900 rounded-2xl p-5 shadow-lg border border-slate-800"
              >
                <div className="shrink-0 w-14 h-14 rounded-xl bg-yellow-500 text-slate-900 flex items-center justify-center">
                  {item.icon}
                </div>
                <div className="text-left">
                  <div className="text-white font-extrabold text-lg leading-tight">
                    {item.label}
                  </div>
                  <p className="text-white font-bold text-sm leading-snug mt-1">
                    {item.subtitle}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Project Expertise ── */}
      <section className="py-20 bg-slate-900 relative overflow-hidden">
        {/* background glow */}
        <div className="absolute inset-0 pointer-events-none opacity-20">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-yellow-500 rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-amber-400 rounded-full blur-3xl" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-yellow-500/20 rounded-full border border-yellow-400/30 mb-5">
              <span className="w-2 h-2 rounded-full bg-yellow-400 animate-pulse" />
              <span className="text-yellow-400 font-semibold text-sm uppercase tracking-widest">
                Sectors We Serve
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Project <span className="text-yellow-400">Expertise</span>
            </h2>
            <p className="text-slate-400 text-lg max-w-2xl mx-auto leading-relaxed">
              We cater to a wide range of project categories bringing
              precision, creativity, and expertise to every sector we touch.
            </p>
            <div className="mt-6 w-20 h-1 bg-gradient-to-r from-yellow-400 to-amber-500 mx-auto rounded-full" />
          </div>

          {/* Category Pills Grid */}
          <div className="flex flex-wrap justify-center gap-4">
            {projectCategories.map((cat, index) => (
              <div
                key={index}
                className="group flex items-center gap-3 bg-white/5 border border-white/10 hover:border-yellow-400/60 hover:bg-yellow-500/10 rounded-2xl px-6 py-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-yellow-500/10 cursor-default"
              >
                <span className="text-2xl group-hover:scale-110 transition-transform duration-300">
                  {cat.icon}
                </span>
                <span className="text-white font-semibold text-sm group-hover:text-yellow-400 transition-colors duration-300 whitespace-nowrap">
                  {cat.label}
                </span>
              </div>
            ))}
          </div>

          {/* Bottom tagline */}
          <p className="text-center text-slate-500 text-sm mt-12 tracking-wide">
            From concept to completion across every sector, every scale.
          </p>
        </div>
      </section>
      {/* Testimonials */}
      <Testimonials />

      {/* About Section */}
      <section id="about" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              About Our Expertise
            </h2>
          </div>
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">
                Comprehensive Design Solutions
              </h3>
              <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed">
                We know that design is a process that cannot be done "in the
                flick of an eye." So our main focus is, before starting any
                project, we ask ourselves to do as deep research as we can do in
                relevance to the client and their requirements.
              </p>
              <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed">
                Arch Point has successfully executed several prestigious real
                estate projects, including residential, commercial, health
                clubs, spas and salons, pharmaceutical, exhibition spaces,
                hospitality, institutional and other high integrated projects.
              </p>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
                We also offer design services for the built environment,
                encompassing master planning, architectural, landscape,
                interior, lighting and furniture design.
              </p>
            </div>
            <div>
              <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-lg">
                <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-4">
                  Our Commitment
                </h4>
                <p className="text-base text-gray-600 mb-6 leading-relaxed">
                  "Our aim is the satisfaction of our clients, to achieve this
                  our team work hard for the proper presentation of their
                  thoughts regarding the design, so that you can visualize your
                  dream building in reality."
                </p>
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <p className="text-yellow-800 font-medium text-center text-sm sm:text-base">
                    Specializing in Quantum Architecture - Your vibes matter to
                    us
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          {/* Section Header */}
          <div className="text-center mb-8 sm:mb-10">
            <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">
              Our Directors
            </h2>
            <div className="w-12 h-0.5 bg-yellow-500 mx-auto"></div>
          </div>

          {/* Directors Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl mx-auto">
            {directors.map((director) => (
              <div
                key={director.id}
                className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden border border-gray-100"
              >
                {/* Image */}
                <div className="w-full aspect-[4/3]">
                  <img
                    src={director.image}
                    alt={director.name}
                    className="w-full h-full object-contain object-top rounded-t-lg"
                  />
                </div>

                {/* Content */}
                <div className="p-4">
                  <h3 className="font-bold text-gray-900 text-base sm:text-lg mb-1">
                    {director.name}
                  </h3>
                  <p className="text-yellow-600 font-medium text-sm mb-2">
                    {director.title}
                  </p>
                  <div className="flex items-center justify-between"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Contact Form */}
      <Inquiry />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default PMCLandingPage;